angular.module('impactx.list').controller('ListPaginationCtrl', [
    '$element',
    'TranslationService',
    '$timeout',
    'PaginationService',
    '$route',
    '$securityManager',
    ListPaginationController
]);

function ListPaginationController($element, TranslationService, $timeout, PaginationService, $route, $securityManager) {
    var self = this;
    self.buttons = [];
    self.displayButtons = [];
    self.selectedButton = {};
    self.currentPage = 1;
    self.previousPageIndex = 0;
    var MAXIMUM_DISPLAYED_BUTTONS = 7;
    var container;

    self.$onInit = function () {
        container = $element;
        self.trns = {
            of: TranslationService.get('of'),
            rows: TranslationService.get("rows")
        };
        self.rowButtons = $securityManager.isSuperUser() ? [10, 20, 50, 100, 200] : [10,20, 50];
    };

    self.$onChanges = function (changes) {
        var newPageNumber = impactX.isDefined(changes, 'maxPageNumber.currentValue');
        if (newPageNumber >= 0) {
            self.buttons = [];
            for (var i = 1; i <= newPageNumber; i++) {
                self.buttons.push({number: i});
            }
            updateView();
            notifySmartTable();
        }
        var newCurrentPage = impactX.isDefined(changes, 'currentPage.currentValue');
        if (newCurrentPage >= 0) {
            self.selectedButton = self.buttons[newCurrentPage - 1];
            updateView();
        }
        var newMaxRowNumber = impactX.isDefined(changes, 'maxRowNumber.currentValue');
        if (newMaxRowNumber >= 0) {
            updateView();
            notifySmartTable();
        }
    };

    self.onNumberOfRowsChange = function(newValue, oldValue) {
        PaginationService.setNumberOfLines(newValue, self.listId);
/*        var firstItem = oldValue * (self.currentPage - 1) + 1;
        var newCurrentPage = Math.ceil(firstItem / newValue);*/
        self.selectPage(1);
        $route.reload();
    };

    self.selectPage = function (selectedPageNumber) {
        self.previousPageIndex = self.currentPage;
        self.currentPage = selectedPageNumber;
        onPageSelect();
    };

    self.previousPage = function () {
        if (self.currentPage > 1) {
            self.previousPageIndex = self.currentPage;
            self.currentPage--;
            onPageSelect();
        }
    };

    self.nextPage = function () {
        if (self.currentPage < self.buttons.length) {
            self.previousPageIndex = self.currentPage;
            self.currentPage++;
            onPageSelect();
        }
    };

    function onPageSelect() {
        updateView();
        self.selectedButton = self.buttons[self.currentPage - 1];
        self.onPageChange({pageNumber: self.currentPage}).then(function () {
            notifySmartTable();
        });
    }

    function updateView() {
        updateRowCounter();
        updateDisplayButtons();
    }

    function updateDisplayButtons() {
        self.displayButtons = [];
        var minimum = Math.max(1, self.currentPage - Math.abs(Math.floor(MAXIMUM_DISPLAYED_BUTTONS / 2)));
        var maximum = minimum + MAXIMUM_DISPLAYED_BUTTONS;

        if (maximum > self.maxPageNumber) {
            maximum = self.maxPageNumber + 1;
            minimum = Math.max(1, maximum - MAXIMUM_DISPLAYED_BUTTONS);
        }

        for (var i = minimum; i < maximum; i++) {
            self.displayButtons.push({number: i});
        }
    }

    function updateRowCounter() {
        self.currentDisplayMin = self.maxRowNumber == 0 ? 0 : (self.currentPage - 1) * self.rowsPerPage + 1;
        self.currentDisplayMax = Math.min(self.currentPage * self.rowsPerPage, self.maxRowNumber);
    }

    /**
     * Function to notify smart table about the page change.
     * The timeout is set to avoid false page selection because digest cycle isn't triggered properly.
     * Unfortunatly this makes the list flicker if the previous page is selected.
     */
    function notifySmartTable() {
        if (self.previousPageIndex <= self.currentPage) {
            $timeout(function () {
                self.smartTableCtrl.slice((self.currentPage - 1) * self.rowsPerPage, self.rowsPerPage);
            });
        }
        else {
            self.smartTableCtrl.slice((self.currentPage - 1) * self.rowsPerPage, self.rowsPerPage);
        }
    }
}